import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';

const useConfirmDialog = () => {
  const [dialog, setDialog] = React.useState({
    open: false,
    title: '',
    message: '',
    onConfirm: () => {},
    onCancel: () => {},
    confirmText: 'Yes',
    cancelText: 'Cancel',
  });

  const showConfirmDialog = React.useCallback(({
    title,
    message,
    onConfirm,
    onCancel = () => {},
    confirmText = 'Yes',
    cancelText = 'Cancel',
  }) => {
    setDialog({
      open: true,
      title,
      message,
      onConfirm,
      onCancel,
      confirmText,
      cancelText,
    });
  }, []);

  const handleConfirm = React.useCallback(() => {
    if (dialog.onConfirm) {
      dialog.onConfirm();
    }
    setDialog(prev => ({ ...prev, open: false }));
  }, [dialog.onConfirm]);

  const handleCancel = React.useCallback(() => {
    if (dialog.onCancel) {
      dialog.onCancel();
    }
    setDialog(prev => ({ ...prev, open: false }));
  }, [dialog.onCancel]);

  const ConfirmDialog = React.useCallback(() => (
    <Dialog
      open={dialog.open}
      onClose={handleCancel}
      aria-labelledby="confirm-dialog-title"
      aria-describedby="confirm-dialog-description"
    >
      <DialogTitle id="confirm-dialog-title">
        {dialog.title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="confirm-dialog-description">
          {dialog.message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} color="primary">
          {dialog.cancelText}
        </Button>
        <Button onClick={handleConfirm} color="primary" variant="contained" autoFocus>
          {dialog.confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  ), [dialog, handleConfirm, handleCancel]);

  return {
    showConfirmDialog,
    ConfirmDialog,
  };
};

export default useConfirmDialog;
